"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthResponseSchema = void 0;
const zod_1 = require("zod");
exports.healthResponseSchema = zod_1.z.object({
    service: zod_1.z.literal("crewfsm-api"),
    status: zod_1.z.literal("ok"),
    timestamp: zod_1.z.string().datetime({ offset: true }),
    version: zod_1.z.string().min(1),
});
//# sourceMappingURL=health.js.map